<template>
  <main>
    <van-cell-group>
      <van-field
        v-model="phone"
        clearable
        disabled
        label="手机"
        placeholder="请输入手机"
      />
      <van-field
        v-model="name"
        clearable
        label="姓名"
        placeholder="请输入姓名"
      />
      <van-field
        v-model="contactPhone"
        clearable
        label="联系号码"
        placeholder="请输入联系号码"
      />
      <van-field
        v-model="idCardCode"
        clearable
        label="身份证号"
        placeholder="请输入身份证号"
      />
      <van-field
        v-model="gender"
        clearable
        readonly
        label="性别"
        placeholder="请输入性别"
        @click="show = true"
      />
    </van-cell-group>
    <div class="p-3">
      <van-button
        type="primary"
        size="large"
        @click="handleOnSubmit">确认修改</van-button>
    </div>
    <van-actionsheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      @select="onSelect"
      @cancel="onCancel"
    />
  </main>
</template>

<script>
export default {
  name: 'UserInfo',
  data() {
    return {
      name: '',
      phone: '',
      contactPhone: '',
      idCardCode: '',
      gender: '',
      show: false,
      actions: [
        {
          name: '男',
        },
        {
          name: '女',
        },
      ],
    };
  },
  computed: {
    genderName() {
      const map = new Map();
      map.set('1', '未填写');
      map.set('2', '男');
      map.set('3', '女');
      map.set('4', '未知');
      return map;
    },
    genderCode() {
      const map = new Map();
      map.set('未填写', '1');
      map.set('男', '2');
      map.set('女', '3');
      map.set('未知', '4');
      return map;
    },
  },
  mounted() {
    this.handleLoad();
  },
  methods: {
    onSelect(item) {
      this.gender = item.name;
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    async handleLoad() {
      const accessToken = localStorage.getItem('accessToken');
      const response = await this.$http.get('/patient-api/webapi/weixin/mp/get-user-info', {
        access_token: accessToken,
      });
      this.name = response.name;
      this.phone = response.phone;
      this.contactPhone = response.contact_phone;
      this.idCardCode = response.id_card_code;
      this.gender = this.genderName.get(response.gender_code);
    },
    async handleOnSubmit() {
      const {
        name, gender, contactPhone, idCardCode,
      } = this;
      const genderCode = this.genderCode.get(gender);
      const params = {
        name,
        gender_code: genderCode,
        id_card_code: idCardCode,
        contact_phone: contactPhone,
      };
      if (idCardCode.includes('**')) {
        delete params.id_card_code;
      }
      const accessToken = localStorage.getItem('accessToken');
      await this.$http.post('/patient-api/webapi/hospital-patient/update', params, {
        Authorization: `Bearer ${accessToken}`,
      });
      this.$toast.success('更新成功');
    },
  },
};
</script>
